/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkuStatisticsResVo
 */
export interface SkuStatisticsResVo {
    /**
     * SPU总数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    spuTotal?: number;
    /**
     * SKU总数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    skuTotal?: number;
    /**
     * SKU_PRODUCT总数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    skuProductTotal?: number;
    /**
     * 已启用SPU数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    spuEnabled?: number;
    /**
     * 已禁用SPU数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    spuDisabled?: number;
    /**
     * 已启用SKU数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    skuEnabled?: number;
    /**
     * 已禁用SKU数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    skuDisabled?: number;
    /**
     * 上架商品会员数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    enabledUserCount?: number;
    /**
     * 下架商品会员数
     * @type {number}
     * @memberof SkuStatisticsResVo
     */
    disabledUserCount?: number;
}

/**
 * Check if a given object implements the SkuStatisticsResVo interface.
 */
export function instanceOfSkuStatisticsResVo(value: object): value is SkuStatisticsResVo {
    return true;
}

export function SkuStatisticsResVoFromJSON(json: any): SkuStatisticsResVo {
    return SkuStatisticsResVoFromJSONTyped(json, false);
}

export function SkuStatisticsResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuStatisticsResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuTotal': json['spuTotal'] == null ? undefined : json['spuTotal'],
        'skuTotal': json['skuTotal'] == null ? undefined : json['skuTotal'],
        'skuProductTotal': json['skuProductTotal'] == null ? undefined : json['skuProductTotal'],
        'spuEnabled': json['spuEnabled'] == null ? undefined : json['spuEnabled'],
        'spuDisabled': json['spuDisabled'] == null ? undefined : json['spuDisabled'],
        'skuEnabled': json['skuEnabled'] == null ? undefined : json['skuEnabled'],
        'skuDisabled': json['skuDisabled'] == null ? undefined : json['skuDisabled'],
        'enabledUserCount': json['enabledUserCount'] == null ? undefined : json['enabledUserCount'],
        'disabledUserCount': json['disabledUserCount'] == null ? undefined : json['disabledUserCount'],
    };
}

export function SkuStatisticsResVoToJSON(json: any): SkuStatisticsResVo {
    return SkuStatisticsResVoToJSONTyped(json, false);
}

export function SkuStatisticsResVoToJSONTyped(value?: SkuStatisticsResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuTotal': value['spuTotal'],
        'skuTotal': value['skuTotal'],
        'skuProductTotal': value['skuProductTotal'],
        'spuEnabled': value['spuEnabled'],
        'spuDisabled': value['spuDisabled'],
        'skuEnabled': value['skuEnabled'],
        'skuDisabled': value['skuDisabled'],
        'enabledUserCount': value['enabledUserCount'],
        'disabledUserCount': value['disabledUserCount'],
    };
}

